import React, { useContext, useEffect } from 'react';
import { format } from 'date-fns';
import { trackClickEventProp54 } from '../../../utils/omnitureUtils';
import RouteInfoContext from '../../route_info/RouteInfoContext';
import CalenderSlider from '../CalenderSlider/CalenderSlider';
import '../../../styles/BookABus.css';

type BookListing = {
  close: () => void;
  source: string;
  destination: string;
};

const getValidDate = (str: string) => {
  if (!str) return null;

  try {
    const intialDate = str.split('-');
    const validDate = new Date(+intialDate[2], +intialDate[1], +intialDate[0]);
    const finalValidDate = format(validDate, 'd MMM');
    return finalValidDate;
  } catch (e) {
    //
  }
};

const BookListing = ({ close, source, destination }: BookListing) => {
  const trainsData = useContext(RouteInfoContext);
  const busData = trainsData?.busSeoRoutes?.busGroups
    ?.find((busGroup) => busGroup.groupName === 'Private Buses')
    ?.buses?.splice(0, 10);
  const sourceCityCode = trainsData?.busSeoRoutes?.sourceCityCode;
  const destinationCityCode = trainsData?.busSeoRoutes?.destinationCityCode;

  const handleBusLink = (doj) => {
    trackClickEventProp54('trains_seo_route_cp_bus_selected');
    window.location.href = `https://www.makemytrip.com/bus/search/${source}/${destination}/${doj}?from_code=${sourceCityCode}&to_code=${destinationCityCode}&source=Rails_SEO_Route_Template`;
  };

  const redirectToBus = (completeDate?: string) => {
    const date = new Date();
    const doj = completeDate ? completeDate : format(date, 'dd-MM-yyyy');
    handleBusLink(doj);
  };

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <div className="listPopup">
      <div className="popupHeader">
        <span className="font22 latoBlack">{`${source} to ${destination} Trains`}</span>
        <span className="close" onClick={close}>
          &nbsp;
        </span>
      </div>
      <div className="calWrap">
        <CalenderSlider redirectToBus={redirectToBus} />
      </div>
      <ul className="busListWrap">
        {busData?.map((bus) => {
          const {
            operatorName,
            noOfRatings,
            rating,
            busType,
            availableSeats,
            avlWindowSeats,
            departureTimeStr,
            arrivalTimeStr,
            minFare,
            durationInMins,
            doj,
            arrivalDate
          } = bus;

          const hours = Math.floor(durationInMins / 60);
          const mins = durationInMins % 60;

          const validDoj = getValidDate(doj);
          const validArrivalDate = getValidDate(arrivalDate);

          let ratingClass = 'good';
          if (rating < 4) {
            ratingClass = 'average';
          }

          return (
            <li className="listCard appendBottom15" onClick={() => handleBusLink(doj)}>
              <div className="flexOne boxPadding">
                <div className="makeFlex hrtlCenter appendBottom10">
                  <span className="font18 latoBlack">{operatorName}</span>
                  <div className="pushRight makeFlex hrtlCenter">
                    {!!noOfRatings && <span className="appendRight10 lightGreyText font14">{noOfRatings} Reviews</span>}
                    {!!rating && (
                      <span className={`userRating latoBold ${ratingClass}`}>
                        <span className="whiteStarIcon busListSprite appendRight5">&nbsp;</span>
                        {rating}
                      </span>
                    )}
                  </div>
                </div>
                <div className="makeFlex font14 darkGreyText appendBottom20">
                  {!!busType && <span>{busType}</span>}
                  <span className="appendLeft10 appendRight10 lightGreyText">|</span>
                  {!!availableSeats && (
                    <span className="makeFlex hrtlCenter">
                      <span className="seatleftIcon busListSprite appendRight5 font12"></span> {availableSeats} Seats
                      Left
                      <span className="appendLeft10 appendRight10 lightGreyText">|</span>
                    </span>
                  )}
                  {!!avlWindowSeats && (
                    <span className="makeFlex hrtlCenter appendLeft10">
                      <span className="windowSeatIcon busListSprite appendRight5 font12"></span> {avlWindowSeats} Window
                      Seats
                    </span>
                  )}
                </div>
                <div className="makeFlex hrtlCenter appendBottom20">
                  <span className="latoBold font20" dangerouslySetInnerHTML={{ __html: departureTimeStr }} />
                  <span className="appendRight10 font16">
                    {` `},&nbsp;{validDoj}
                  </span>
                  <span className="travelTime makeFlex hrtlCenter darkGreyText">{`${hours} hrs ${mins} mins`}</span>
                  <span className="appendLeft20 latoBold font20" dangerouslySetInnerHTML={{ __html: arrivalTimeStr }} />
                  <span className="appendRight10 font16">
                    {` `},&nbsp;{validArrivalDate}
                  </span>
                </div>
                <ul className="makeFlex hrtlCenter font12 darkGreyText">
                  {/* will be uncommented once free date change goes live /*}
                  {/* <li className="makeFlex hrtlCenter appendRight20">
                    <span className="dateChangeIcon busListSprite appendRight5"></span>Free Date Change
                  </li> */}
                  <li className="makeFlex hrtlCenter">
                    <span className="liveTrackIcon busListSprite appendRight5"></span>Live Tracking
                  </li>
                </ul>
              </div>
              <div className="makeFlex column boxPadding priceBox">
                <p className="font28 latoBlack textCenter">&#8377;{minFare}</p>
                <a className="bluePrimarybtn pushBottom font12 lineHeight22">Select Seats</a>
              </div>
            </li>
          );
        })}
      </ul>
      <p className="makeFlex perfectCenter appendBottom20">
        <div className="bluePrimarybtn moreBus" onClick={() => redirectToBus()}>
          View More buses
        </div>
      </p>
    </div>
  );
};

export default BookListing;
